import React, { useState, useCallback, useRef, useEffect } from 'react';
import './HomePage.css';
import DynamicButton from './Components/DynamicBtn.js';
import OrderModal from './Components/OrderModel.js';
import { placeOrder, getOrder, fetchWalletData, getWinnersHistory, lastOrderCancel } from './apiService.js';
import Result from './Pages/Result.js';
import ChangePass from './Pages/ChangePass.js';
import Account from './Pages/Account.js';
import Report from './Pages/Report.js';
import BarcodeInput from './Components/BarcodeScan.js';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import rupee5 from './Assets/BALAJI Game- Button no 5.png';
import rupee10 from './Assets/BALAJI Game- Button no 10.png';
import rupee25 from './Assets/BALAJI Game- Button no 25.png';
import rupee50 from './Assets/BALAJI Game- Button no 50.png';
import rupee100 from './Assets/BALAJI Game- Button no 100.png';
import rupee200 from './Assets/BALAJI Game- Button no 200.png';
import rupee500 from './Assets/BALAJI Game- Button no 500.png';
import balajilogo from './Assets/balaji logo.png';
import jocker from './Assets/JOKER.png';
import allsp from './Assets/All SP Button png.png';
import alldp from './Assets/All DP Button png.png';
import alltp from './Assets/All TP Button png.png';
import CancelBtn from './Assets/Cancel Button png.png';
import ClearBtn from './Assets/Clear Button png.png';
import FCGroupBtn from './Assets/FC Group Button png.png';
import Barcodeimg from './Assets/barcodeimg.jpg';
import PrintBtn from './Assets/Print Button png.png';
import RePrintBtn from './Assets/Reprint Button png.png';
import ResultBtn from './Assets/Result Button png.png';
import RupeesBtn from './Assets/Rs Button png.png';
import AdvanceBtn from './Assets/Advance Button png.png';
import balanceBtn from './Assets/Balance Button png (1).png';
import CancelOrderModal from './Pages/CancelOrder.js';
import singleDouble from './Assets/leftsideimg.png';
import yellowArrow from './Assets/yellowarrow.png';
import yellowArrowDown from './Assets/yellowarrowdown.png';
import logoutss from './Assets/logouts.png';
import acountimgs from './Assets/acountimgs.jpg';
import userINFO from './Assets/usersinfo.png';
import { useReactToPrint } from 'react-to-print';
import Reprint from './Pages/Reprint.js';
import PrintSlip from './Components/printSlip.js';
import JokerBadge from './Components/JokerBadge.jsx';
import { IoMdRefresh } from "react-icons/io";


const leftTableData = [
  ['1', '2', '3', '4', '5'],
  ['128', '129', '120', '130', '140'],
  ['137', '138', '139', '149', '159'],
  ['146', '147', '148', '158', '168'],
  ['236', '156', '157', '167', '230'],
  ['245', '237', '238', '239', '249'],
  ['290', '246', '247', '248', '258'],
  ['380', '345', '256', '257', '267'],
  ['470', '390', '346', '347', '348'],
  ['489', '480', '490', '356', '357'],
  ['560', '570', '580', '590', '456'],
  ['579', '589', '670', '680', '690'],
  ['678', '679', '689', '789', '780'],
  ['100', '110', '166', '112', '113'],
  ['119', '200', '229', '220', '122'],
  ['155', '228', '300', '266', '177'],
  ['227', '255', '337', '338', '339'],
  ['335', '336', '355', '400', '366'],
  ['344', '499', '445', '446', '447'],
  ['399', '660', '599', '455', '500'],
  ['588', '688', '779', '699', '799'],
  ['669', '778', '788', '770', '889'],
  ['777', '444', '111', '888', '555'],
];
const middleTableData = [
  ['6', '7', '8', '9', '0'],
  ['123', '124', '125', '126', '127'],
  ['150', '160', '134', '135', '136'],
  ['169', '179', '170', '180', '145'],
  ['178', '250', '189', '234', '190'],
  ['240', '269', '260', '270', '235'],
  ['259', '278', '279', '289', '280'],
  ['268', '340', '350', '360', '370'],
  ['349', '359', '369', '379', '389'],
  ['358', '368', '378', '450', '460'],
  ['367', '458', '459', '469', '479'],
  ['457', '467', '468', '478', '569'],
  ['790', '890', '567', '568', '578'],
  ['114', '115', '116', '117', '118'],
  ['277', '133', '224', '144', '226'],
  ['330', '188', '233', '199', '244'],
  ['448', '223', '288', '225', '299'],
  ['466', '377', '440', '388', '334'],
  ['556', '449', '477', '559', '488'],
  ['600', '557', '558', '577', '550'],
  ['880', '566', '800', '667', '668'],
  ['899', '700', '990', '900', '677'],
  ['222', '999', '666', '333', '000'],
];

const HomePage = () => {
  // selection states
  const [selectedRowsLeft, setSelectedRowsLeft] = useState([]);
  const [selectedRowsMiddle, setSelectedRowsMiddle] = useState([]);
  const [selectedNumbers, setSelectedNumbers] = useState(new Set());
  const [amounts, setAmounts] = useState({});
  const [currentAmount, setCurrentAmount] = useState('');
  const [baseAmounts, setBaseAmounts] = useState({}); // store base amount per number for increments/decrements
  const rightClickCountsRef = useRef({}); // track number of consecutive right-clicks per number
  // refs that mirror state for immediate synchronous reads (helps when clicks happen
  // before state updates have propagated)
  const amountsRef = useRef({});
  const baseAmountsRef = useRef({});
  const allDataRef = useRef({});

  // When a chip (rupee button) is clicked and there's no current selection,
  // we set this pending amount so the next number click applies it directly.
  const [pendingChipAmount, setPendingChipAmount] = useState(null);

  const [lastSelected, setLastSelected] = useState(null);
  const [openPage, setOpenPage] = useState(false);
  const [changePassword, setChangePassword] = useState(false);
  const [isAccountOpen, setIsAccountOpen] = useState(false);
  const [isReportOpen, setIsReportOpen] = useState(false);
  const [selectedButtons, setSelectedButtons] = useState(new Set()); // unchanged usage (if needed elsewhere)
  const [isFcGroupSelected, setIsFcGroupSelected] = useState(false);
  const [allData, setAllData] = useState({});
  const [nextResultTme, setNextResultTime] = useState(null);
  const [isOrderModelOpen, setIsOrderModelOpen] = useState(false);
  const [isPrintBtnDisable, setIsPrintBtnDisable] = useState(false);
  const [orderData, setOrderData] = useState({});
  const [totalAmount, setTotalAmount] = useState(0);
  const [allResultData, setAllResultData] = useState([]);
  const [walletData, setWalletData] = useState([]);
  const [orderPrint, setOrderPrint] = useState(false);
  const [winnersHistory, setWinnersHistory] = useState([]);
  const [inActiveHours, setInActiveHours] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [reprintModalOpen, setReprintModalOpen] = useState(false);
  const [orderPrintData, setOrderPrintData] = useState(null);
  const hiddenInputRef = useRef(null);
  const componentRef = useRef(null);
  const [time, setTime] = useState(new Date());
  // offset (ms) between authoritative time and local Date.now().
  // If a user has wrong system time, we compute offset = accurateNow - Date.now()
  const [timeOffsetMs, setTimeOffsetMs] = useState(0);
  const [isTimeSynced, setIsTimeSynced] = useState(false);
  // keep a ref copy so interval callbacks always read latest offset without recreating intervals
  const timeOffsetRef = useRef(0);
  const [numbers, setNumbers] = useState([1, 2, 4]);
  const [timer, setTimer] = useState(300); // 5 minutes in seconds
  const [isSpinning, setIsSpinning] = useState(false);
  const [showResultAnim, setShowResultAnim] = useState(false);
  // barcode input UI state + ref
  const [barcodeInputVisible, setBarcodeInputVisible] = useState(false);

  // --- add these states near the other useState declarations ---
  const [isInteractionDisabled, setIsInteractionDisabled] = useState(false);
  const [showNoMoreBeatsPopup, setShowNoMoreBeatsPopup] = useState(false);
  // Disable interaction during last 5 seconds BEFORE spinner starts (show popup),
  // and while spinner is running (block page but don't show the "No More Beats" popup).
  useEffect(() => {
    // If we are in the last 5 seconds (timer in seconds countdown) and spinner hasn't started yet
    if (timer <= 5 && timer > 0 && !isSpinning) {
      setShowNoMoreBeatsPopup(true);
      setIsInteractionDisabled(true);
    } else if (isSpinning) {
      // During spinning, block interactions (no popup)
      setShowNoMoreBeatsPopup(false);
      setIsInteractionDisabled(true);
    } else {
      // Normal state: allow interaction
      setShowNoMoreBeatsPopup(false);
      setIsInteractionDisabled(false);
    }
  }, [timer, isSpinning]);

  // track previous popup state to start spinner when popup closes
  const prevNoBeatsRef = useRef(false);
  useEffect(() => {
    const prev = prevNoBeatsRef.current;
    if (prev && !showNoMoreBeatsPopup) {
      // popup just closed — if we're still within last 5s, start the spinner
      if (!isSpinning && timer <= 5) {
        startSpinning();
      }
    }
    prevNoBeatsRef.current = showNoMoreBeatsPopup;
  }, [showNoMoreBeatsPopup, isSpinning, timer]);

  const [modalOpenFromBarcode, setModalOpenFromBarcode] = useState(false);
  const barcodeInputRef = useRef(null);
  const wrapperRef = useRef(null);

  // add these near your other refs (once)
  const spinIntervalRef = useRef(null);
  const winnerTimeoutRef = useRef(null);
  const stopTimeoutRef = useRef(null);

  const [advanceOpen, setAdvanceOpen] = useState(false);
  const [advanceTimes, setAdvanceTimes] = useState([]); // [{ iso: 'HH:MM', label: 'h:mm AM' }]
  const [selectedAdvanceTime, setSelectedAdvanceTime] = useState(null);
  const [advanceSessionCount, setAdvanceSessionCount] = useState(''); // legacy: quick-count input
  const [showAdvanceModal, setShowAdvanceModal] = useState(false); // legacy state for inline input
  const [advanceSessionsModalOpen, setAdvanceSessionsModalOpen] = useState(false); // new sessions selection modal
  const [selectedAdvanceSessions, setSelectedAdvanceSessions] = useState([]); // array of iso times (confirmed)
  const [tempSelectedAdvanceSessions, setTempSelectedAdvanceSessions] = useState([]); // temporary work selection while modal open
  const advanceRef = useRef(null);
  const advanceLoopRef = useRef(null); // track ongoing advance order loop
  // FC groups mapping (each group is an array of numbers as strings)
  const fcGroups = [
    ['111', '116', '166', '666'],
    ['112', '117', '126', '167', '266', '667'],
    ['113', '118', '136', '168', '366', '668'],
    ['114', '119', '146', '169', '466', '669'],
    ['110', '115', '156', '160', '566', '660'],
    ['122', '127', '177', '226', '267', '677'],
    ['123', '128', '137', '178', '236', '268', '367', '678'],
    ['124', '129', '147', '179', '246', '269', '467', '679'],
    ['120', '125', '157', '170', '256', '260', '567', '670'],
    ['133', '138', '188', '336', '368', '688'],
    ['134', '139', '148', '189', '346', '369', '468', '689'],
    ['130', '135', '158', '180', '356', '360', '568', '680'],
    ['144', '149', '199', '446', '469', '699'],
    ['140', '145', '159', '190', '456', '460', '569', '690'],
    ['100', '150', '155', '556', '560', '600'],
    ['222', '227', '277', '777'],
    ['223', '228', '237', '278', '377', '778'],
    ['224', '229', '247', '279', '477', '779'],
    ['220', '225', '257', '270', '577', '770'],
    ['233', '238', '288', '337', '378', '788'],
    ['234', '239', '248', '289', '347', '379', '478', '789'],
    ['230', '235', '258', '280', '357', '370', '578', '780'],
    ['240', '245', '259', '290', '457', '470', '579', '790'],
    ['244', '249', '299', '447', '479', '799'],
    ['200', '250', '255', '557', '570', '700'],
    ['333', '338', '388', '888'],
    ['334', '339', '348', '389', '488', '889'],
    ['330', '335', '358', '380', '588', '880'],
    ['344', '349', '399', '448', '489', '899'],
    ['340', '345', '359', '390', '458', '480', '589', '890'],
    ['300', '350', '355', '558', '580', '800'],
    ['444', '449', '499', '999'],
    ['440', '445', '459', '490', '599', '990'],
    ['400', '450', '455', '559', '590', '900'],
    ['000', '500', '550', '555']
  ];
  const advanceQueueRef = useRef([]); // queued advance jobs when near session end
  const advanceQueueProcessingRef = useRef(false);
  const QUEUE_NEAR_TIME_THRESHOLD = 8; // seconds — if within this time, queue instead of immediate place
  const [queuedAdvanceCount, setQueuedAdvanceCount] = useState(0);

  // return Date object for the next session time (same logic as getSessionTime but returns Date)
  const now = () => new Date(Date.now() + (timeOffsetRef.current || 0));

  const getNextSessionDateObj = () => {
    const nowDate = now();
    const mins = nowDate.getMinutes();
    const remainder = mins % 5;
    const delta = (remainder === 0 && nowDate.getSeconds() === 0) ? 0 : 5 - remainder;
    const target = new Date(nowDate);
    target.setMinutes(mins + delta, 0, 0);
    return target;
  };

  const pad2 = (n) => String(n).padStart(2, '0');

  // format date -> "HH:MM" 24h string
  const toHHMM = (date) => `${pad2(date.getHours())}:${pad2(date.getMinutes())}`;

  // format date -> "h:mm AM/PM"
  const formatDateTo12 = (date) => {
    let h = date.getHours();
    const m = date.getMinutes();
    const ampm = h >= 12 ? 'PM' : 'AM';
    h = h % 12 || 12;
    return `${h}:${pad2(m)} ${ampm}`;
  };


  const generateAdvanceTimes = () => {
    // Start from next session then +5 (so we show future sessions after the immediate next).
    const nextSession = getNextSessionDateObj();
    const start = new Date(nextSession.getTime() + 5 * 60 * 1000);

    // Game window: 07:00 -> 23:55 (today)
    const today = now();
    const gameStart = new Date(today);
    gameStart.setHours(7, 0, 0, 0);
    const gameEnd = new Date(today);
    gameEnd.setHours(23, 55, 0, 0);

    // If start is before gameStart, start from gameStart.
    const listStart = start < gameStart ? new Date(gameStart) : start;

    const times = [];
    let cur = new Date(listStart);
    while (cur <= gameEnd) {
      times.push({
        iso: toHHMM(cur),       // 'HH:MM' 24-hour string (good for sending to APIs)
        label: formatDateTo12(cur) // 'h:mm AM/PM' for UI
      });
      cur = new Date(cur.getTime() + 5 * 60 * 1000);
    }

    setAdvanceTimes(times);
  };

  const getAdvanceSessionList = (count) => {
    const arr = [];
    const baseSessionTime = getSessionTime();
    const baseMinutes = parseInt(baseSessionTime.split(':')[0]) * 60 + parseInt(baseSessionTime.split(':')[1]);
    for (let i = 0; i < count; i++) {
      const totalMinutes = baseMinutes + (i + 1) * 5;
      const hours = Math.floor((totalMinutes / 60) % 24);
      const minutes = totalMinutes % 60;
      arr.push(`${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`);
    }
    return arr;
  };

  const toggleTempAdvanceSession = (iso) => {
    setTempSelectedAdvanceSessions(prev => {
      if (prev.includes(iso)) return prev.filter(x => x !== iso);
      return [...prev, iso];
    });
  };

  const selectAllTempAdvance = () => setTempSelectedAdvanceSessions(advanceTimes.map(t => t.iso));
  const clearTempAdvance = () => setTempSelectedAdvanceSessions([]);


  const toggleAdvanceDropdown = () => {
    const willOpen = !advanceOpen;
    setAdvanceOpen(willOpen);
    if (willOpen) generateAdvanceTimes();
  };


  useEffect(() => {
    function handleDocClick(e) {
      if (!advanceOpen) return;
      if (advanceRef.current && !advanceRef.current.contains(e.target)) {
        setAdvanceOpen(false);
      }
    }

    document.addEventListener('mousedown', handleDocClick);
    document.addEventListener('touchstart', handleDocClick);
    return () => {
      document.removeEventListener('mousedown', handleDocClick);
      document.removeEventListener('touchstart', handleDocClick);
    };
  }, [advanceOpen]);


  const onBarcodeClick = () => {
    setBarcodeInputVisible(true);
    setTimeout(() => barcodeInputRef.current?.focus(), 50);
  };

  useEffect(() => {
    if (!barcodeInputVisible) return;

    requestAnimationFrame(() => {
      if (barcodeInputRef.current && typeof barcodeInputRef.current.focus === "function") {
        barcodeInputRef.current.focus();
        return;
      }
      const el = wrapperRef.current?.querySelector("input, textarea");
      if (el && typeof el.focus === "function") el.focus();
    });
  }, [barcodeInputVisible]);

  useEffect(() => {
    function handleDocMouseDown(e) {
      if (!barcodeInputVisible) return;

      // If the click is inside the barcode modal, ignore it.
      // We look for either the class we add to the modal (.barcode-modal)
      // OR any element with role="dialog" (some modals have this).
      const modalEl = document.querySelector('.barcode-modal, .ReactModal__Content, [role="dialog"]');
      if (modalEl && modalEl.contains(e.target)) {
        return; // click inside modal — do nothing
      }

      // Otherwise, if click is outside the wrapper, hide the input
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setBarcodeInputVisible(false);
      }
    }

    function handleKeyDown(e) {
      if (!barcodeInputVisible) return;

      // If modal is open, ignore Escape for closing barcode input
      if (modalOpenFromBarcode) return;

      if (e.key === "Escape") setBarcodeInputVisible(false);
    }

    document.addEventListener("mousedown", handleDocMouseDown);
    document.addEventListener("touchstart", handleDocMouseDown);
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("mousedown", handleDocMouseDown);
      document.removeEventListener("touchstart", handleDocMouseDown);
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [barcodeInputVisible, modalOpenFromBarcode]);
  // --- timer / spinner logic preserved (no changes) ---
  useEffect(() => {
    const interval = setInterval(() => setTime(now()), 1000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const updateTimer = () => {
      const nowDate = now();
      const seconds = nowDate.getMinutes() * 60 + nowDate.getSeconds();
      const secondsIntoBlock = seconds % 300;
      const remaining = 300 - secondsIntoBlock;
      setTimer(remaining === 300 ? 300 : remaining);
    };
    updateTimer();
    const id = setInterval(updateTimer, 1000);
    return () => clearInterval(id);
  }, []);

  useEffect(() => {
    if (timer === 300) {
      startSpinning();
    }
  }, [timer]);

  // Process queued advance orders when spinner finishes and we're in a safe window
  useEffect(() => {
    if (!isSpinning && advanceQueueRef.current && advanceQueueRef.current.length > 0) {
      processAdvanceQueue();
    }
  }, [isSpinning]);


  // replace startSpinning with this
  const startSpinning = () => {
    // prevent re-entrancy
    if (spinIntervalRef.current) return;

    setIsSpinning(true);

    // start the visual randomizing
    spinIntervalRef.current = setInterval(() => {
      setNumbers([
        Math.floor(Math.random() * 10),
        Math.floor(Math.random() * 10),
        Math.floor(Math.random() * 10),
      ]);
    }, 100);

    // After 5s, call winnerHistory. When it resolves (or errors), stop the spinner immediately.
    winnerTimeoutRef.current = setTimeout(async () => {
      try {
        await winnerHistory();
      } catch (err) {
        console.error("Error fetching winner history:", err);
      } finally {
        // cancel safety fallback (so it won't run later)
        if (stopTimeoutRef.current) {
          clearTimeout(stopTimeoutRef.current);
          stopTimeoutRef.current = null;
        }

        // stop spinner as soon as the response finishes (success or fail)
        if (spinIntervalRef.current) {
          clearInterval(spinIntervalRef.current);
          spinIntervalRef.current = null;
        }
        setIsSpinning(false);
      }
    }, 6000);

    // Safety fallback: ensure spinner does not run indefinitely (stop at 8s)
    // This will be cancelled in the finally block above if winnerHistory finishes first.
    stopTimeoutRef.current = setTimeout(() => {
      if (spinIntervalRef.current) {
        clearInterval(spinIntervalRef.current);
        spinIntervalRef.current = null;
      }
      setIsSpinning(false);
      stopTimeoutRef.current = null;
    }, 10000);
  };

  // cleanup effect — clear timeouts/intervals on unmount
  useEffect(() => {
    return () => {
      if (spinIntervalRef.current) {
        clearInterval(spinIntervalRef.current);
        spinIntervalRef.current = null;
      }
      if (winnerTimeoutRef.current) {
        clearTimeout(winnerTimeoutRef.current);
        winnerTimeoutRef.current = null;
      }
      if (stopTimeoutRef.current) {
        clearTimeout(stopTimeoutRef.current);
        stopTimeoutRef.current = null;
      }
    };
  }, []);

  // Trigger a reveal animation when spinner stops and we have a result
  useEffect(() => {
    // If spinner turned off and we have latest result digits, play the animation
    if (!isSpinning && singledigit && singledigit.length === 3) {
      setShowResultAnim(true);
      const t = setTimeout(() => setShowResultAnim(false), 2400);
      return () => clearTimeout(t);
    }
  }, [isSpinning, winnersHistory]);

  const formatTime = (sec) => {
    const m = String(Math.floor(sec / 60)).padStart(2, "0");
    const s = String(sec % 60).padStart(2, "0");
    return `${m}:${s}`;
  };

  const handleAfterPrint = useCallback(() => {
    setIsPrintBtnDisable(false);
    setSelectedAdvanceTime(null);
  }, []);
  const handleBeforePrint = useCallback(() => Promise.resolve(), []);
  const printFn = useReactToPrint({
    contentRef: componentRef,
    documentTitle: "OrderSlip",
    onAfterPrint: handleAfterPrint,
    onBeforePrint: handleBeforePrint,
  });



  // returns the HTML string of your PrintSlip
  const getReceiptHTML = () => {
    if (!componentRef.current) return '';
    return `
    <html>
      <head>
        <style>
          body {
            font-family: Arial, sans-serif;
            font-size: 12px;
            margin: 0;
            padding: 0;
            width: 80mm; /* typical thermal paper width */
          }
          .print-slip { width: 100%; }
          .logo-container img { width: 50%; margin: 0 auto; display: block; }
          .text-center { text-align: center; }
          .order-details span { display: block; }
          .total { font-weight: bold; margin-top: 5px; }
          .barcode-container { text-align: center; margin-top: 5px; }
          hr { border: none; border-top: 1px dashed #000; margin: 5px 0; }
        </style>
      </head>
      <body>
        ${componentRef.current.innerHTML}
      </body>
    </html>
  `;
  };



  const handleSilentPrint = async () => {
    if (!window?.electron) {
      console.warn("Not running inside Electron. Printing disabled.");
      return false;
    }

    try {
      const html = getReceiptHTML();
      if (!html) {
        console.error("PrintSlip content not found.");
        return false;
      }

      const res = await window.electron.printHtmlSilent({
        html,
        deviceName: 'Your Thermal Printer Name', // optional, leave undefined to use default
        printBackground: true
      });

      if (!res.success) {
        console.error("Silent print failed:", res.failureReason || res.error);
      } else {
        console.log("Silent print success");
      }
    } catch (err) {
      console.error("Error during silent print:", err);
    }
  };


  const handleOnClick = useCallback(() => {

    handleSilentPrint();
    setTimeout(() => {
      if (componentRef.current) {
        printFn();
        console.log("in printing");
      } else {
        console.error("PrintSlip not available.");
        setIsPrintBtnDisable(false);
        setSelectedAdvanceTime(null);
      }
    }, 1000);
  }, [printFn]);

  // ------------------ Selection logic --------------------

  const toggleRowSelection = (rowIndex, tableData, setSelectedRows, selectedRows) => {
    const newSelectedRows = [...selectedRows];
    const newNumbers = new Set(selectedNumbers);

    const wasSelected = newSelectedRows.includes(rowIndex);

    if (wasSelected) {
      // Deselect row
      newSelectedRows.splice(newSelectedRows.indexOf(rowIndex), 1);
      tableData[rowIndex].forEach(num => newNumbers.delete(num));
      // If lastSelected was from this row, clear it
      if (tableData[rowIndex].includes(lastSelected)) setLastSelected(null);
    } else {
      // Prefer incrementing existing amounts on the row (so left-click arrow always increases
      // amounts if any exist) — even if a chip is currently pending. If no existing amounts,
      // then apply a pending chip (if any) or select the row.
      const rowNums = tableData[rowIndex] || [];
      // Check refs first so rapid updates (typed/chip applies) are visible immediately
      const anyHasAmount = rowNums.some(n => (amountsRef.current && amountsRef.current.hasOwnProperty(n) && Number(amountsRef.current[n]) !== 0) || (allDataRef.current && allDataRef.current.hasOwnProperty(n) && Number(allDataRef.current[n]) !== 0) || (amounts && amounts.hasOwnProperty(n) && Number(amounts[n]) !== 0));
      if (anyHasAmount) {
        // Increase each existing amount in the row by its base (left-click arrow = increase)
        const updatedBases = { ...(baseAmountsRef.current || baseAmounts) };
        rowNums.forEach(n => {
          const raw = (amountsRef.current && amountsRef.current.hasOwnProperty(n)) ? amountsRef.current[n] : ((amounts && amounts.hasOwnProperty(n)) ? amounts[n] : (allDataRef.current && allDataRef.current.hasOwnProperty(n) ? allDataRef.current[n] : (allData && allData.hasOwnProperty(n) ? allData[n] : undefined)));
          const current = raw === undefined || raw === '' ? 0 : Number(raw) || 0;
          if (current !== 0) {
            const base = (baseAmountsRef.current && baseAmountsRef.current.hasOwnProperty(n)) ? Number(baseAmountsRef.current[n]) : (current || 1);
            const newAmt = current + base;
            updateAmountForNumber(n, newAmt);
            // record into the local updatedBases map for a single synchronous update below
            updatedBases[n] = base;
          }
        });
        // Write baseAmounts in one go (and mirror to ref) so subsequent clicks read it immediately
        setBaseAmounts(updatedBases);
        baseAmountsRef.current = updatedBases;
      } else if (pendingChipAmount !== null) {
        // If a chip is pending and no amounts exist on this row, apply it to the entire row's numbers
        applyAmountToNumbers(tableData[rowIndex], pendingChipAmount);
      } else {
        // Select row: add row and add numbers to selectedNumbers set
        newSelectedRows.push(rowIndex);
        tableData[rowIndex].forEach(num => newNumbers.add(num));
        // set lastSelected to first number of that row (convenience)
        setLastSelected(tableData[rowIndex][0]);
      }
    }

    setSelectedRows(newSelectedRows);
    setSelectedNumbers(newNumbers);
    if (hiddenInputRef.current) hiddenInputRef.current.focus();
  };

  // Apply a numeric amount to a list of numbers (strings/numbers) in state.
  // This updates `amounts`, `allData`, `baseAmounts` and resets right-click counters.
  const applyAmountToNumbers = (numsArray, amount) => {
    if (!numsArray || numsArray.length === 0) return;
    const amt = amount === '' || amount === null || amount === undefined ? '' : (isNaN(Number(amount)) ? amount : Number(amount));

    // build updated objects (use refs as source-of-truth for sync correctness)
    const prevAmounts = { ...(amountsRef.current || amounts) };
    const prevAllData = { ...(allDataRef.current || allData) };
    const prevBase = { ...(baseAmountsRef.current || baseAmounts) };

    const updatedAmounts = { ...prevAmounts };
    const updatedAllData = { ...prevAllData };
    const updatedBase = { ...prevBase };

    numsArray.forEach(n => {
      if (amt === '' || amt === 0) {
        if (updatedAmounts.hasOwnProperty(n)) delete updatedAmounts[n];
        if (updatedAllData.hasOwnProperty(n)) delete updatedAllData[n];
        if (updatedBase.hasOwnProperty(n)) delete updatedBase[n];
      } else {
        updatedAmounts[n] = amt;
        updatedAllData[n] = amt;
        updatedBase[n] = amt;
      }
    });

    setAmounts(updatedAmounts);
    amountsRef.current = updatedAmounts;

    setAllData(updatedAllData);
    allDataRef.current = updatedAllData;

    setBaseAmounts(updatedBase);
    baseAmountsRef.current = updatedBase;

    // reset right-click counters for these numbers
    const counts = { ...(rightClickCountsRef.current || {}) };
    numsArray.forEach(n => { counts[n] = 0; });
    rightClickCountsRef.current = counts;

    if (hiddenInputRef.current) hiddenInputRef.current.focus();
  };

  // Helper to update a single number's amount (used by number and arrow handlers)
  const updateAmountForNumber = (num, newAmount) => {
    const prevAmounts = { ...(amountsRef.current || amounts) };
    const prevAllData = { ...(allDataRef.current || allData) };

    const updated = { ...prevAmounts };
    const updatedAll = { ...prevAllData };

    if (newAmount === undefined || newAmount === null || newAmount === '' || Number(newAmount) === 0) {
      if (updated.hasOwnProperty(num)) delete updated[num];
      if (updatedAll.hasOwnProperty(num)) delete updatedAll[num];
    } else {
      updated[num] = Number(newAmount);
      updatedAll[num] = Number(newAmount);
    }

    setAmounts(updated);
    amountsRef.current = updated;

    setAllData(updatedAll);
    allDataRef.current = updatedAll;
  };

  const handleNumberToggle = (value, event) => {
    // We handle three interactions:
    // - left-click (event.type === 'click')
    //    * if an amount exists for the number: DECREMENT by base amount (don't toggle selection)
    //    * otherwise: toggle selection (existing behaviour)
    // - right-click / contextmenu (event.type === 'contextmenu')
    //    * if an amount exists for the number: INCREMENT by base * N where N increases on each right-click
    //    * otherwise: set amount to base 1 (or ignore) — we'll treat missing base as 1
    // Prevent native context menu for right-clicks
    const evType = event && event.type ? event.type : 'click';

    // Treat an amount as present — prefer refs so rapid updates are visible immediately.
    const currentRaw = (amountsRef.current && amountsRef.current.hasOwnProperty(value)) ? amountsRef.current[value]
      : ((allDataRef.current && allDataRef.current.hasOwnProperty(value)) ? allDataRef.current[value]
        : ((amounts && amounts.hasOwnProperty(value)) ? amounts[value] : (allData && allData.hasOwnProperty(value) ? allData[value] : undefined)));
    const currentNum = currentRaw === undefined || currentRaw === '' ? 0 : Number(currentRaw) || 0;
    const hasAmount = currentNum !== 0;

    // DEBUG: temporary - log fast click state to help reproduce increment issue
    // Remove these logs after debugging
    // eslint-disable-next-line no-console
    console.debug && console.debug('[DBG] handleNumberToggle', { value, evType, currentRaw, currentNum, hasAmount, pendingChipAmount });

    // If FC-group mode is active and the clicked number belongs to a FC group,
    // apply the action to the entire group (select, increment, decrement, or apply pending chip).
    const findFcGroup = (num) => {
      const s = String(num);
      for (const grp of fcGroups) if (grp.includes(s)) return grp;
      return null;
    };

    if (isFcGroupSelected) {
      const group = findFcGroup(value);
      if (group) {
        // determine whether any number in the group currently has an amount
        const groupHasAmount = group.some(n => {
          const raw = (amountsRef.current && amountsRef.current.hasOwnProperty(n)) ? amountsRef.current[n]
            : ((allDataRef.current && allDataRef.current.hasOwnProperty(n)) ? allDataRef.current[n]
              : ((amounts && amounts.hasOwnProperty(n)) ? amounts[n] : (allData && allData.hasOwnProperty(n) ? allData[n] : undefined)));
          const num = raw === undefined || raw === '' ? 0 : Number(raw) || 0;
          return num !== 0;
        });

        if (evType === 'click') {
          // LEFT click: increment existing amounts by base, or apply pending chip to those without amounts,
          // or toggle selection of the whole group when none have amounts and no chip pending.
          if (groupHasAmount) {
            const nextBase = { ...(baseAmountsRef.current || baseAmounts) };
            group.forEach(n => {
              const raw = (amountsRef.current && amountsRef.current.hasOwnProperty(n)) ? amountsRef.current[n]
                : ((allDataRef.current && allDataRef.current.hasOwnProperty(n)) ? allDataRef.current[n]
                  : ((amounts && amounts.hasOwnProperty(n)) ? amounts[n] : (allData && allData.hasOwnProperty(n) ? allData[n] : undefined)));
              const current = raw === undefined || raw === '' ? 0 : Number(raw) || 0;
              if (current !== 0) {
                const base = nextBase.hasOwnProperty(n) ? Number(nextBase[n]) : (current || 1);
                const newAmt = current + base;
                nextBase[n] = base;
                updateAmountForNumber(n, newAmt);
              } else if (pendingChipAmount !== null) {
                const amt = isNaN(Number(pendingChipAmount)) ? pendingChipAmount : Number(pendingChipAmount);
                updateAmountForNumber(n, amt);
                nextBase[n] = amt;
              }
            });
            setBaseAmounts(nextBase);
            baseAmountsRef.current = nextBase;
            if (hiddenInputRef.current) hiddenInputRef.current.focus();
            return;
          }

          if (!groupHasAmount && pendingChipAmount !== null) {
            const amt = isNaN(Number(pendingChipAmount)) ? pendingChipAmount : Number(pendingChipAmount);
            applyAmountToNumbers(group, amt);
            if (hiddenInputRef.current) hiddenInputRef.current.focus();
            return;
          }

          // Toggle group selection: if all selected -> deselect, else select all
          const newSet = new Set(selectedNumbers);
          const allSelected = group.every(n => newSet.has(n));
          if (allSelected) group.forEach(n => newSet.delete(n)); else group.forEach(n => newSet.add(n));
          setSelectedNumbers(newSet);
          setLastSelected(group[0]);
          if (hiddenInputRef.current) hiddenInputRef.current.focus();
          return;
        }

        if (evType === 'contextmenu') {
          // RIGHT click: decrease amounts for group members that have amounts.
          try { event.preventDefault(); } catch (e) { /* ignore */ }
          const nextBase = { ...(baseAmountsRef.current || baseAmounts) };
          group.forEach(n => {
            const raw = (amountsRef.current && amountsRef.current.hasOwnProperty(n)) ? amountsRef.current[n]
              : ((allDataRef.current && allDataRef.current.hasOwnProperty(n)) ? allDataRef.current[n]
                : ((amounts && amounts.hasOwnProperty(n)) ? amounts[n] : (allData && allData.hasOwnProperty(n) ? allData[n] : undefined)));
            const current = raw === undefined || raw === '' ? 0 : Number(raw) || 0;
            if (current !== 0) {
              const base = (nextBase && nextBase.hasOwnProperty(n)) ? Number(nextBase[n]) : (current || 1);
              const newAmt = current - base;
              if (newAmt > 0) {
                updateAmountForNumber(n, newAmt);
              } else {
                updateAmountForNumber(n, 0);
                if (nextBase.hasOwnProperty(n)) delete nextBase[n];
                const counts = { ...(rightClickCountsRef.current || {}) };
                if (counts.hasOwnProperty(n)) delete counts[n];
                rightClickCountsRef.current = counts;
              }
            }
          });
          setBaseAmounts(nextBase);
          baseAmountsRef.current = nextBase;
          if (hiddenInputRef.current) hiddenInputRef.current.focus();
          return;
        }
      }
    }

    // Debugging aid: log click type and current amounts (remove or silence later)
    // console.debug('handleNumberToggle', { value, evType, currentRaw, currentNum, hasAmount });

    // NOTE: we handle pendingChipAmount later only when there is no existing amount —
    // prefer incrementing existing amounts when present (so left-click always increments).

    // NOTE: use the top-level updateAmountForNumber (which also keeps refs in sync)

    if (evType === 'click') {
      // Left-click behaviour: INCREASE current amount by the base on each left-click.
      // Also, if a chip is pending, consume it on left-click (apply to this number).
      // Note: we handle pendingChipAmount earlier, so here we only handle increment when amount exists.

      if (hasAmount) {
        const base = (baseAmountsRef.current && baseAmountsRef.current.hasOwnProperty(value)) ? Number(baseAmountsRef.current[value]) : (currentNum || 1);
        const current = currentNum;
        const newAmt = current + base;
        // record base for consistent future increments (update ref immediately)
        const nextBase = { ...(baseAmountsRef.current || baseAmounts) };
        nextBase[value] = base;
        setBaseAmounts(nextBase);
        baseAmountsRef.current = nextBase;
        // eslint-disable-next-line no-console
        console.debug && console.debug('[DBG] left-click increment', { value, current, base, newAmt });
        updateAmountForNumber(value, newAmt);
        if (hiddenInputRef.current) hiddenInputRef.current.focus();
        return;
      }

      // If there is a pending chip and the number currently has NO amount,
      // apply the pending chip to this number (do not override existing amounts).
      if (!hasAmount && pendingChipAmount !== null) {
        const amt = isNaN(Number(pendingChipAmount)) ? pendingChipAmount : Number(pendingChipAmount);
        const updatedAmounts = { ...(amountsRef.current || amounts) };
        const updatedAll = { ...(allDataRef.current || allData) };
        const updatedBase = { ...(baseAmountsRef.current || baseAmounts) };
        updatedAmounts[value] = amt;
        updatedAll[value] = amt;
        updatedBase[value] = amt;
        setAmounts(updatedAmounts);
        amountsRef.current = updatedAmounts;
        setAllData(updatedAll);
        allDataRef.current = updatedAll;
        setBaseAmounts(updatedBase);
        baseAmountsRef.current = updatedBase;
        const counts = { ...(rightClickCountsRef.current || {}) };
        counts[value] = 0;
        rightClickCountsRef.current = counts;
        // eslint-disable-next-line no-console
        console.debug && console.debug('[DBG] applied pendingChipAmount to', { value, amt });
        if (hiddenInputRef.current) hiddenInputRef.current.focus();
        return;
      }

      // No amount: behave as toggle selection (existing behaviour)
      const newSet = new Set(selectedNumbers);
      // treat every click as Ctrl/Cmd toggling membership
      if (newSet.has(value)) {
        newSet.delete(value);
        if (lastSelected === value) setLastSelected(null);
      } else {
        newSet.add(value);
        setLastSelected(value);
      }
      setSelectedNumbers(newSet);
      if (hiddenInputRef.current) hiddenInputRef.current.focus();
      return;
    }

    if (evType === 'contextmenu') {
      // Right-click behaviour: DECREASE current amount by the base on each right-click.
      // Prevent native context menu.
      try { event.preventDefault(); } catch (e) { /* ignore */ }

      if (hasAmount) {
        const base = (baseAmounts && baseAmounts.hasOwnProperty(value)) ? Number(baseAmounts[value]) : (currentNum || 1);
        const current = currentNum;
        const newAmt = current - base;
        // eslint-disable-next-line no-console
        console.debug && console.debug('[DBG] right-click decrement', { value, current, base, newAmt });
        if (newAmt > 0) {
          updateAmountForNumber(value, newAmt);
        } else {
          // remove amount completely and clear base tracking / counters
          updateAmountForNumber(value, 0);
          const nextBase = { ...(baseAmountsRef.current || baseAmounts) };
          if (nextBase.hasOwnProperty(value)) delete nextBase[value];
          setBaseAmounts(nextBase);
          baseAmountsRef.current = nextBase;
          const counts = { ...(rightClickCountsRef.current || {}) };
          if (counts.hasOwnProperty(value)) delete counts[value];
          rightClickCountsRef.current = counts;
        }
      }

      if (hiddenInputRef.current) hiddenInputRef.current.focus();
      return;
    }
  };
  // --- replace your applyAmountInstantly with this ---

  const applyAmountInstantly = (valueStr) => {
    // valueStr is a string (possibly empty while typing). We store numbers for non-empty.
    const value = valueStr === '' ? '' : Number(valueStr);

    // Build updated amounts synchronously using refs so clicks immediately use newest values
    const prevAmounts = { ...(amountsRef.current || amounts) };
    const updated = { ...prevAmounts };

    const applyToList = (list) => {
      list.forEach(n => {
        if (valueStr === '' || value === 0) {
          if (updated.hasOwnProperty(n)) delete updated[n];
        } else {
          updated[n] = value;
        }
      });
    };

    if (selectedNumbers && selectedNumbers.size > 0) {
      applyToList(Array.from(selectedNumbers));
    } else if ((selectedRowsLeft && selectedRowsLeft.length > 0) || (selectedRowsMiddle && selectedRowsMiddle.length > 0)) {
      selectedRowsLeft.forEach(ri => (leftTableData[ri] || []).forEach(n => { if (valueStr === '' || value === 0) delete updated[n]; else updated[n] = value; }));
      selectedRowsMiddle.forEach(ri => (middleTableData[ri] || []).forEach(n => { if (valueStr === '' || value === 0) delete updated[n]; else updated[n] = value; }));
    } else if (lastSelected != null) {
      if (valueStr === '' || value === 0) delete updated[lastSelected]; else updated[lastSelected] = value;
    }

    setAmounts(updated);
    amountsRef.current = updated;
    setAllData(updated);
    allDataRef.current = updated;
  };

  // --- replace your handleAmountSelect with this ---
  const handleAmountSelect = (amount) => {
    // amount can be string or number (chip value). We normalize to number/string usage below.
    const amountStr = amount === null || amount === undefined ? '' : String(amount);

    // clear typed amount state (so UI reflects that we've applied it)
    setCurrentAmount('');

    // Build updated amounts and baseAmounts synchronously so refs are correct immediately
    const updated = { ...(amountsRef.current || amounts) };
    const nextBase = { ...(baseAmountsRef.current || baseAmounts) };

    if (selectedNumbers && selectedNumbers.size > 1) {
      selectedNumbers.forEach(num => {
        updated[num] = isNaN(Number(amountStr)) ? amountStr : Number(amountStr);
        nextBase[num] = isNaN(Number(amountStr)) ? amountStr : Number(amountStr);
      });
    } else if (selectedNumbers && selectedNumbers.size === 1) {
      const only = Array.from(selectedNumbers)[0];
      updated[only] = isNaN(Number(amountStr)) ? amountStr : Number(amountStr);
      nextBase[only] = isNaN(Number(amountStr)) ? amountStr : Number(amountStr);
    } else if ((selectedRowsLeft && selectedRowsLeft.length > 0) || (selectedRowsMiddle && selectedRowsMiddle.length > 0)) {
      selectedRowsLeft.forEach(ri => (leftTableData[ri] || []).forEach(n => { updated[n] = isNaN(Number(amountStr)) ? amountStr : Number(amountStr); nextBase[n] = isNaN(Number(amountStr)) ? amountStr : Number(amountStr); }));
      selectedRowsMiddle.forEach(ri => (middleTableData[ri] || []).forEach(n => { updated[n] = isNaN(Number(amountStr)) ? amountStr : Number(amountStr); nextBase[n] = isNaN(Number(amountStr)) ? amountStr : Number(amountStr); }));
    } else if (lastSelected != null) {
      updated[lastSelected] = isNaN(Number(amountStr)) ? amountStr : Number(amountStr);
      nextBase[lastSelected] = isNaN(Number(amountStr)) ? amountStr : Number(amountStr);
    }

    // write state and refs synchronously
    setAmounts(updated);
    amountsRef.current = updated;
    setAllData(updated);
    allDataRef.current = updated;
    setBaseAmounts(nextBase);
    baseAmountsRef.current = nextBase;

    // --- IMPORTANT: clear the hidden input element's value (so it doesn't show old text) ---
    if (hiddenInputRef.current) {
      try { hiddenInputRef.current.value = ''; } catch (e) { /* ignore */ }
      hiddenInputRef.current.focus();
    }

    // --- clear selection after applying the amount so UI no longer shows the number as selected ---
    setSelectedNumbers(new Set());
    setSelectedRowsLeft([]);
    setSelectedRowsMiddle([]);
    setLastSelected(null);
  };

  // --- replace your handleKeyboardAmountInput with this ---
  const handleKeyboardAmountInput = (event) => {
    // keyboard-driven: event.key exists for real key events; if you call it programmatically
    // with a string/number, handle that outside (we keep old behaviour where you could call with
    // a value and it applies).
    if (event && event.key) {
      if (event.key === 'Backspace') {
        setCurrentAmount(prev => {
          const newVal = prev.slice(0, -1);
          applyAmountInstantly(newVal); // instantly update amounts as user types/backspaces
          return newVal;
        });
      } else if (/^\d$/.test(event.key)) {
        setCurrentAmount(prev => {
          const newVal = prev + event.key;
          applyAmountInstantly(newVal); // instantly update amounts for the selection
          return newVal;
        });
      } else if (event.key === 'Enter') {
        // finalize typed amount: apply to selection and then clear selection & input
        const final = currentAmount;
        if (final && final.length > 0) {
          handleAmountSelect(final);
        } else {
          // if there's nothing typed, do nothing but ensure hidden input is cleared
          if (hiddenInputRef.current) hiddenInputRef.current.value = '';
        }
        // clear typed field
        setCurrentAmount('');
      } else {
        // ignore other keys
      }
    } else {
      // If invoked programmatically with a raw value (number/string), treat as apply
      handleAmountSelect(event);
    }
  };

  // Helpers (place inside HomePage component)
  const addNumbersToSelection = (numsArray, replace = false) => {
    // replace=false -> add to existing selection (default)
    // replace=true  -> replace current selection with these numbers
    const updated = replace ? new Set() : new Set(selectedNumbers);
    numsArray.forEach(n => updated.add(n));
    setSelectedNumbers(updated);
    if (hiddenInputRef.current) hiddenInputRef.current.focus();
  };

  const handleArrowAfterFirstRowClick = (tableData, colIndex) => {
    if (!tableData || tableData.length <= 14) return;
    const nums = [];
    for (let r = 1; r < 13; r++) {
      const row = tableData[r];
      if (!row) continue;
      if (colIndex >= 0 && colIndex < row.length) {
        nums.push(row[colIndex]);
      }
    }
    if (nums.length) {
      // If any number in this column already has an amount, left-click should
      // behave as INCREMENT for those numbers (matching per-number left-click behavior).
      const anyHasAmount = nums.some(n => (amountsRef.current && amountsRef.current.hasOwnProperty(n) && Number(amountsRef.current[n]) !== 0) || (allDataRef.current && allDataRef.current.hasOwnProperty(n) && Number(allDataRef.current[n]) !== 0) || (amounts && amounts.hasOwnProperty(n) && Number(amounts[n]) !== 0));
      if (anyHasAmount) {
        const updatedBases = { ...(baseAmountsRef.current || baseAmounts) };
        nums.forEach(n => {
          const raw = (amountsRef.current && amountsRef.current.hasOwnProperty(n)) ? amountsRef.current[n] : ((amounts && amounts.hasOwnProperty(n)) ? amounts[n] : (allDataRef.current && allDataRef.current.hasOwnProperty(n) ? allDataRef.current[n] : (allData && allData.hasOwnProperty(n) ? allData[n] : undefined)));
          const current = raw === undefined || raw === '' ? 0 : Number(raw) || 0;
          if (current !== 0) {
            const base = (baseAmountsRef.current && baseAmountsRef.current.hasOwnProperty(n)) ? Number(baseAmountsRef.current[n]) : (current || 1);
            const newAmt = current + base;
            updateAmountForNumber(n, newAmt);
            updatedBases[n] = base;
          }
        });
        setBaseAmounts(updatedBases);
        baseAmountsRef.current = updatedBases;
      } else if (pendingChipAmount !== null) {
        // apply chip to column but do not leave the column selected
        applyAmountToNumbers(nums, pendingChipAmount);
      } else {
        addNumbersToSelection(nums);
      }
    }
  };

  const handleArrowAfterThirteenthRowClick = (tableData, colIndex) => {
    // selects column colIndex for all rows with index >= 13, skipping each row's last column.
    if (!tableData || tableData.length <= 13) return;
    const nums = [];
    for (let r = 13; r < tableData.length - 1; r++) {
      const row = tableData[r];
      if (!row) continue;
      if (colIndex >= 0 && colIndex < row.length) {
        nums.push(row[colIndex]);
      }
    }
    if (nums.length) {
      const anyHasAmount = nums.some(n => (amountsRef.current && amountsRef.current.hasOwnProperty(n) && Number(amountsRef.current[n]) !== 0) || (allDataRef.current && allDataRef.current.hasOwnProperty(n) && Number(allDataRef.current[n]) !== 0) || (amounts && amounts.hasOwnProperty(n) && Number(amounts[n]) !== 0));
      if (anyHasAmount) {
        const updatedBases = { ...(baseAmountsRef.current || baseAmounts) };
        nums.forEach(n => {
          const raw = (amountsRef.current && amountsRef.current.hasOwnProperty(n)) ? amountsRef.current[n] : ((amounts && amounts.hasOwnProperty(n)) ? amounts[n] : (allDataRef.current && allDataRef.current.hasOwnProperty(n) ? allDataRef.current[n] : (allData && allData.hasOwnProperty(n) ? allData[n] : undefined)));
          const current = raw === undefined || raw === '' ? 0 : Number(raw) || 0;
          if (current !== 0) {
            const base = (baseAmountsRef.current && baseAmountsRef.current.hasOwnProperty(n)) ? Number(baseAmountsRef.current[n]) : (current || 1);
            const newAmt = current + base;
            updateAmountForNumber(n, newAmt);
            updatedBases[n] = base;
          }
        });
        setBaseAmounts(updatedBases);
        baseAmountsRef.current = updatedBases;
      } else if (pendingChipAmount !== null) {
        applyAmountToNumbers(nums, pendingChipAmount);
      } else {
        addNumbersToSelection(nums);
      }
    }
  };

  // renderTable (drop-in replacement)
  const renderTable = useCallback((tableData, selectedRows, setSelectedRows) => (
    <>
      {tableData?.map((numbersArr, rowIndex) => {
        // each regular data row
        const dataRow = (
          <tr key={`data-row-${rowIndex}`}>
            {numbersArr?.map((number, numIndex) => {
              const isSelected = selectedRows.includes(rowIndex) || selectedNumbers.has(number);
              return (
                <td
                  key={`cell-${rowIndex}-${numIndex}`}
                  style={{ border: '1.8px solid black' }}
                  onContextMenu={(e) => { e.preventDefault(); handleNumberToggle(number, e); }}
                >
                  <DynamicButton
                    value={number}
                    selected={isSelected}
                    onClick={handleNumberToggle}   // expects (value, event)
                    amount={amounts[number]}
                  />
                </td>
              );
            })}
            <td
              key={`row-arrow-${rowIndex}`}
              className="arrow-cell"
              onClick={() => toggleRowSelection(rowIndex, tableData, setSelectedRows, selectedRows)}
              onContextMenu={(e) => {
                try { e.preventDefault(); e.stopPropagation(); } catch (err) { /* ignore */ }
                // right-click on arrow: decrease amounts for this row's numbers by their base (use refs)
                const nums = tableData[rowIndex] || [];
                const updatedBases = { ...(baseAmountsRef.current || baseAmounts) };
                nums.forEach(n => {
                  const raw = (amountsRef.current && amountsRef.current.hasOwnProperty(n)) ? amountsRef.current[n]
                    : ((amounts && amounts.hasOwnProperty(n)) ? amounts[n]
                      : (allDataRef.current && allDataRef.current.hasOwnProperty(n) ? allDataRef.current[n]
                        : (allData && allData.hasOwnProperty(n) ? allData[n] : undefined)));
                  const current = raw === undefined || raw === '' ? 0 : Number(raw) || 0;
                  if (current !== 0) {
                    const base = (baseAmountsRef.current && baseAmountsRef.current.hasOwnProperty(n)) ? Number(baseAmountsRef.current[n]) : (current || 1);
                    const newAmt = current - base;
                    if (newAmt > 0) {
                      updateAmountForNumber(n, newAmt);
                    } else {
                      updateAmountForNumber(n, 0);
                      if (updatedBases.hasOwnProperty(n)) delete updatedBases[n];
                      const counts = { ...(rightClickCountsRef.current || {}) };
                      if (counts.hasOwnProperty(n)) delete counts[n];
                      rightClickCountsRef.current = counts;
                    }
                  }
                });
                setBaseAmounts(updatedBases);
                baseAmountsRef.current = updatedBases;
                if (hiddenInputRef.current) hiddenInputRef.current.focus();
              }}
            >
              <img src={yellowArrow} className="arrow" />
            </td>
          </tr>
        );
        const inserts = [];
        if (rowIndex === 0) {
          inserts.push(
            <tr key="arrow-after-first">
              {numbersArr.map((_, colIndex) => (
                <td key={`af-${colIndex}`}
                  className="arrow-celldown">
                  <img
                    src={yellowArrowDown}
                    className="arrowdown"
                    style={{ cursor: 'pointer' }}
                    alt='down arrow'
                    onClick={(e) => {
                      e.stopPropagation();
                      handleArrowAfterFirstRowClick(tableData, colIndex);
                    }}
                    onContextMenu={(e) => {
                      try { e.preventDefault(); e.stopPropagation(); } catch (err) { /* ignore */ }
                      // Right-click on vertical arrow: decrease each existing amount in this column by base (use refs)
                      const nums = [];
                      for (let r = 1; r < 13; r++) {
                        const row = tableData[r];
                        if (!row) continue;
                        if (colIndex >= 0 && colIndex < row.length) nums.push(row[colIndex]);
                      }
                      const updatedBases = { ...(baseAmountsRef.current || baseAmounts) };
                      nums.forEach(n => {
                        const raw = (amountsRef.current && amountsRef.current.hasOwnProperty(n)) ? amountsRef.current[n]
                          : ((amounts && amounts.hasOwnProperty(n)) ? amounts[n]
                            : (allDataRef.current && allDataRef.current.hasOwnProperty(n) ? allDataRef.current[n]
                              : (allData && allData.hasOwnProperty(n) ? allData[n] : undefined)));
                        const current = raw === undefined || raw === '' ? 0 : Number(raw) || 0;
                        if (current !== 0) {
                          const base = (baseAmountsRef.current && baseAmountsRef.current.hasOwnProperty(n)) ? Number(baseAmountsRef.current[n]) : (current || 1);
                          const newAmt = current - base;
                          if (newAmt > 0) updateAmountForNumber(n, newAmt);
                          else {
                            updateAmountForNumber(n, 0);
                            if (updatedBases.hasOwnProperty(n)) delete updatedBases[n];
                            const counts = { ...(rightClickCountsRef.current || {}) };
                            if (counts.hasOwnProperty(n)) delete counts[n];
                            rightClickCountsRef.current = counts;
                          }
                        }
                      });
                      setBaseAmounts(updatedBases);
                      baseAmountsRef.current = updatedBases;
                      if (hiddenInputRef.current) hiddenInputRef.current.focus();
                    }}
                  />
                </td>
              ))}
              {/* extra cell for the right-side arrow column space */}
              <td key="af-extra" />
            </tr>
          );
        }

        if (rowIndex === 12) {
          // Arrow row AFTER 13th row: arrows under each column that select column colIndex for rows >=13 except last column
          inserts.push(
            <tr key="arrow-after-thirteenth">
              {numbersArr.map((_, colIndex) => (
                <td key={`a13-${colIndex}`}
                  className="arrow-celldown">
                  <img
                    src={yellowArrowDown}
                    className="arrowdown"
                    style={{ cursor: 'pointer' }}
                    alt='down arrow'
                    onClick={(e) => {
                      e.stopPropagation();
                      handleArrowAfterThirteenthRowClick(tableData, colIndex);
                    }}
                    onContextMenu={(e) => {
                      try { e.preventDefault(); e.stopPropagation(); } catch (err) { /* ignore */ }
                      // Right-click on vertical arrow (after 13th): decrease each existing amount in this column by base (use refs)
                      const nums = [];
                      for (let r = 13; r < tableData.length - 1; r++) {
                        const row = tableData[r];
                        if (!row) continue;
                        if (colIndex >= 0 && colIndex < row.length) nums.push(row[colIndex]);
                      }
                      const updatedBases = { ...(baseAmountsRef.current || baseAmounts) };
                      nums.forEach(n => {
                        const raw = (amountsRef.current && amountsRef.current.hasOwnProperty(n)) ? amountsRef.current[n]
                          : ((amounts && amounts.hasOwnProperty(n)) ? amounts[n]
                            : (allDataRef.current && allDataRef.current.hasOwnProperty(n) ? allDataRef.current[n]
                              : (allData && allData.hasOwnProperty(n) ? allData[n] : undefined)));
                        const current = raw === undefined || raw === '' ? 0 : Number(raw) || 0;
                        if (current !== 0) {
                          const base = (baseAmountsRef.current && baseAmountsRef.current.hasOwnProperty(n)) ? Number(baseAmountsRef.current[n]) : (current || 1);
                          const newAmt = current - base;
                          if (newAmt > 0) updateAmountForNumber(n, newAmt);
                          else {
                            updateAmountForNumber(n, 0);
                            if (updatedBases.hasOwnProperty(n)) delete updatedBases[n];
                            const counts = { ...(rightClickCountsRef.current || {}) };
                            if (counts.hasOwnProperty(n)) delete counts[n];
                            rightClickCountsRef.current = counts;
                          }
                        }
                      });
                      setBaseAmounts(updatedBases);
                      baseAmountsRef.current = updatedBases;
                      if (hiddenInputRef.current) hiddenInputRef.current.focus();
                    }}
                  />
                </td>
              ))}
              <td key="a13-extra" />
            </tr>
          );
        }

        // Return the main row followed by any inserts (so arrows are exactly after the specified rows)
        return [dataRow, ...inserts];
      })}
    </>
  ), [selectedNumbers, amounts, handleNumberToggle, toggleRowSelection]);

  // ------------------ rest of your functions (API, UI, order) mostly unchanged --------------------

  const openAccountPopup = () => setIsAccountOpen(true);
  const openResultPopup = () => setOpenPage(true);
  const openReprintPopup = () => setReprintModalOpen(true);
  const openFcgroupPopup = () => {
    setIsFcGroupSelected(prev => {
      const next = !prev;
      toast.info(`FC Group mode ${next ? 'enabled' : 'disabled'}`, { position: 'top-center', autoClose: 900 });
      return next;
    });
  };
  const openChangePasswordPopup = () => setChangePassword(true);
  const openReportPopup = () => setIsReportOpen(true);
  const logout = () => { window.location.href = '/login'; };

  const isInitialRender = useRef(true);
  useEffect(() => {
    if (isInitialRender.current) {
      isInitialRender.current = false;
      fetchOrder();
      winnerHistory();
    }
  }, []);

  // Try to synchronise time with an authoritative public time server.
  // We compute an offset (ms) = serverNow - localNow and use that for all time calculations.
  const syncAccurateTime = async (showToastOnFail = true) => {
    // Try a Kolkata-specific provider first (useful if you want IST), then fall back to worldtimeapi
    const providers = [
      { url: 'https://timeapi.io/api/Time/current/zone?timeZone=Asia/Kolkata', type: 'timeapi.io' },
      { url: 'https://worldtimeapi.org/api/ip', type: 'worldtimeapi' }
    ];

    for (const p of providers) {
      try {
        const res = await fetch(p.url);
        if (!res.ok) throw new Error(`Time API error (${p.type}): ${res.status}`);
        const data = await res.json();

        let serverMs = NaN;
        if (p.type === 'timeapi.io') {
          // timeapi.io returns dateTime like '2025-11-07T13:45:30' in local zone
          if (data && (data.dateTime || data.dateTimeUtc)) {
            const dt = data.dateTime || data.dateTimeUtc;
            serverMs = Date.parse(dt);
          }
        } else if (p.type === 'worldtimeapi') {
          // worldtimeapi returns unixtime (seconds) or utc_datetime
          serverMs = data?.unixtime ? Number(data.unixtime) * 1000 : Date.parse(data.utc_datetime || data.datetime || '');
        }

        if (Number.isFinite(serverMs)) {
          const offset = serverMs - Date.now();
          setTimeOffsetMs(offset);
          timeOffsetRef.current = offset;
          setIsTimeSynced(true);
          setTime(new Date(Date.now() + offset));
          if (showToastOnFail) toast.success('Time synchronized (' + p.type + ')');
          return true;
        }
      } catch (err) {
        // try next provider
        console.warn('Time sync provider failed:', p.url, err);
      }
    }

    // all providers failed — fall back to device time
    setTimeOffsetMs(0);
    timeOffsetRef.current = 0;
    setIsTimeSynced(false);
    if (showToastOnFail) toast.warn('Could not synchronise time — using device clock.');
    return false;
  };

  useEffect(() => {
    let cancelled = false;
    syncAccurateTime();
    // optional: re-sync every 5 minutes while app open
    const id = setInterval(() => { if (!cancelled) syncAccurateTime(false); }, 5 * 60 * 1000);
    return () => { cancelled = true; clearInterval(id); };
  }, []);

  const winnerHistory = async () => {
    try {
      const getwinnerHistory = await getWinnersHistory();
      setWinnersHistory(getwinnerHistory);
    } catch (error) {
      console.error('Error fetching winners:', error);
      toast.error("Please Logged in again Token Expire!!", { position: "top-right", autoClose: 1000 });
    }
  };

  const fetchOrder = async () => {
    try {
      const response = await getOrder();
      setAllResultData(response);
      const getWalletData = await fetchWalletData();
      setWalletData(getWalletData);
    } catch (error) {
      console.error('Error fetching order:', error);
      toast.error("Please Logged in again Token Expire!!", { position: "top-right", autoClose: 1000 });
    }
  };

  // Recompute order data when amounts/allData change
  useEffect(() => {
    handleplaceOrderPrint();
  }, [amounts, allData]);

  const handleplaceOrderPrint = () => {
    const convertedData = Object.fromEntries(
      Object.entries(allData)
        .filter(([key, value]) => value !== 0 && value !== '' && value !== undefined)
        .map(([key, value]) => [String(key), Number(value)])
    );
    setOrderData(convertedData);
    const totalAmounts = Object.values(convertedData).reduce((acc, value) => acc + value, 0);
    setTotalAmount(totalAmounts);
  };

  // let roundedMinutes = Math.ceil((minutes + 1) / 5) * 5;
  function getSessionTime() {
    const nowDate = now();
    const mins = nowDate.getMinutes();
    const remainder = mins % 5;
    const delta = remainder === 0 && nowDate.getSeconds() === 0 ? 0 : 5 - remainder;

    const target = new Date(nowDate);
    target.setMinutes(mins + delta, 0, 0);

    const hh = String(target.getHours()).padStart(2, "0");
    const mm = String(target.getMinutes()).padStart(2, "0");
    return `${hh}:${mm}`;
  }

  const placeOrderForSession = async (sessionTimeStr, isAdvance = false, dataSnapshot = null) => {
    // Place a single order for a given session time
    const sourceData = dataSnapshot || allData;
    const filteredEntries = Object.entries(sourceData).filter(([_, value]) => value !== 0 && value !== '' && value !== undefined);
    if (filteredEntries.length === 0) return false;

    const convertedData = Object.fromEntries(
      filteredEntries.map(([key, value]) => [
        key.toString(),
        { amount: Number(value) }
      ])
    );

    const order = {
      session_time: sessionTimeStr,
      invested_dict: convertedData,
      ...(isAdvance && { is_advance: true }) // add is_advance flag if multi-session
    };

    try {
      const response = await placeOrder(order);
      if (response) {
        setOrderPrintData(response);
        return true;
      }
      return false;
    } catch (error) {
      console.error('Error placing order:', error);
      return false;
    }
  };

  const processAdvanceQueue = async () => {
    if (advanceQueueProcessingRef.current) return;
    if (!advanceQueueRef.current || advanceQueueRef.current.length === 0) return;
    advanceQueueProcessingRef.current = true;
    toast.info('Processing queued advance orders...', { position: 'top-right', autoClose: 1500 });
    setIsPrintBtnDisable(true);

    while (advanceQueueRef.current.length > 0) {
      // Wait until it's safe (not spinning and enough time left)
      while (isSpinning || (typeof timer === 'number' && timer <= QUEUE_NEAR_TIME_THRESHOLD)) {
        await new Promise(r => setTimeout(r, 500));
      }

      const job = advanceQueueRef.current.shift();
      setQueuedAdvanceCount(advanceQueueRef.current.reduce((acc, j) => acc + (j.sessions?.length || 0), 0));
      const { sessions, snapshot } = job;
      if (!sessions || sessions.length === 0) continue;
      for (let i = 0; i < sessions.length; i++) {
        // If we reach a new session start while processing, re-queue remaining sessions and pause.
        if (isSpinning || (typeof timer === 'number' && timer <= QUEUE_NEAR_TIME_THRESHOLD)) {
          const remaining = sessions.slice(i);
          if (remaining.length) {
            advanceQueueRef.current.unshift({ sessions: remaining, snapshot });
            setQueuedAdvanceCount(advanceQueueRef.current.reduce((acc, j) => acc + (j.sessions?.length || 0), 0));
            toast.info('Pausing queued orders because a new result started; will resume shortly', { position: 'top-right', autoClose: 1500 });
          }
          break;
        }
        const sessionTimeStr = sessions[i];
        const success = await placeOrderForSession(sessionTimeStr, true, snapshot);
        if (!success) {
          toast.error(`Failed queued order for ${convertTo12Hour(sessionTimeStr)}`, { position: 'top-right', autoClose: 1500 });
          continue; // try next session
        }
        toast.success(`Queued order placed: ${convertTo12Hour(sessionTimeStr)}`, { position: 'top-right', autoClose: 1000 });
        if (componentRef.current) {
          await new Promise(resolve => setTimeout(resolve, 500));
          handleOnClick();
          await new Promise(resolve => setTimeout(resolve, 1000));
        }
        await fetchOrder();
      }
      toast.success(`Queued ${sessions.length} orders completed`, { position: 'top-right', autoClose: 2000 });
      setQueuedAdvanceCount(advanceQueueRef.current.reduce((acc, j) => acc + (j.sessions?.length || 0), 0));
      setSelectedAdvanceSessions([]);
    }

    advanceQueueProcessingRef.current = false;
    setIsPrintBtnDisable(false);
  };

  const handlePlaceOrder = async (advanceCount = null, advanceSessionsList = null) => {
    setIsPrintBtnDisable(true);
    const filteredEntries = Object.entries(allData).filter(([_, value]) => value !== 0 && value !== '' && value !== undefined);
    if (filteredEntries.length === 0) {
      toast.error("Please select number and amount!", { position: "top-right", autoClose: 1000 });
      setIsPrintBtnDisable(false);
      return;
    }

    // If an explicit list of sessions is provided (selected via advance modal)
    if (Array.isArray(advanceSessionsList) && advanceSessionsList.length > 0) {
      const nearSessionEnd = isSpinning || (typeof timer === 'number' && timer <= QUEUE_NEAR_TIME_THRESHOLD);

      // If we are very close to session end or spinner running, queue this job to process after spinner completes
      if (nearSessionEnd) {
        // store a snapshot of allData for consistency when the queue runs
        const snapshot = { ...(allDataRef.current || allData) };
        advanceQueueRef.current.push({ sessions: advanceSessionsList, snapshot });
        setQueuedAdvanceCount(advanceQueueRef.current.reduce((acc, j) => acc + (j.sessions?.length || 0), 0));
        toast.info(`Orders queued for ${advanceSessionsList.length} sessions; they will be placed after the current result completes.`, { position: "top-right", autoClose: 2000 });
        setIsPrintBtnDisable(false);
        return;
      }
      advanceLoopRef.current = true;
      for (let i = 0; i < advanceSessionsList.length; i++) {
        const sessionTimeStr = advanceSessionsList[i];
        const success = await placeOrderForSession(sessionTimeStr, true);
        if (!success) {
          toast.error(`Failed to place order for session ${i + 1}/${advanceSessionsList.length}`, { position: "top-right", autoClose: 1000 });
          break;
        }
        toast.success(`Order placed for session ${i + 1}/${advanceSessionsList.length}: ${convertTo12Hour(sessionTimeStr)}`, { position: "top-right", autoClose: 1000 });
        if (componentRef.current) {
          await new Promise(resolve => setTimeout(resolve, 500));
          handleOnClick();
          await new Promise(resolve => setTimeout(resolve, 1000));
        }
        await fetchOrder();
      }
      advanceLoopRef.current = false;
      toast.success(`All ${advanceSessionsList.length} orders placed and printed!`, { position: "top-right", autoClose: 2000 });
      resetState();
      setAdvanceSessionCount('');
      setSelectedAdvanceSessions([]);
      setAdvanceSessionsModalOpen(false);
      return;
    }

    // If advanceCount is provided (legacy multi-session advance mode)
    if (advanceCount && advanceCount > 1) {
      const advanceSessions = getAdvanceSessionList(advanceCount);
      const nearSessionEnd = isSpinning || (typeof timer === 'number' && timer <= QUEUE_NEAR_TIME_THRESHOLD);
      if (nearSessionEnd) {
        const snapshot = { ...(allDataRef.current || allData) };
        advanceQueueRef.current.push({ sessions: advanceSessions, snapshot });
        setQueuedAdvanceCount(advanceQueueRef.current.reduce((acc, j) => acc + (j.sessions?.length || 0), 0));
        toast.info(`Orders queued for ${advanceSessions.length} sessions; they will be placed after the current result completes.`, { position: "top-right", autoClose: 2000 });
        setIsPrintBtnDisable(false);
        return;
      }
      advanceLoopRef.current = true;
      for (let i = 0; i < advanceSessions.length; i++) {
        const sessionTimeStr = advanceSessions[i];

        // Place order for this session
        const success = await placeOrderForSession(sessionTimeStr, true);
        if (!success) {
          toast.error(`Failed to place order for session ${i + 1}/${advanceCount}`, { position: "top-right", autoClose: 1000 });
          break;
        }

        toast.success(`Order placed for session ${i + 1}/${advanceCount}: ${convertTo12Hour(sessionTimeStr)}`, { position: "top-right", autoClose: 1000 });

        // Auto-print after each order
        if (componentRef.current) {
          await new Promise(resolve => setTimeout(resolve, 500)); // small delay for print setup
          handleOnClick();
          await new Promise(resolve => setTimeout(resolve, 1000)); // wait for print to start
        }

        await fetchOrder();
      }

      advanceLoopRef.current = false;
      toast.success(`All ${advanceCount} orders placed and printed!`, { position: "top-right", autoClose: 2000 });
      resetState();
      setAdvanceSessionCount('');
      setShowAdvanceModal(false);
      return;
    }

    // Single session order (normal mode)
    const sessionTime = getSessionTime();
    const success = await placeOrderForSession(selectedAdvanceTime || sessionTime, false);
    if (success) {
      toast.success("Order placed successfully.", { position: "top-right", autoClose: 1000 });
      handleOnClick();
      await fetchOrder();
    } else {
      toast.error("Order not placed. Please try again.", { position: "top-right", autoClose: 1000 });
      setIsPrintBtnDisable(false);
    }

    resetState();
  };

  const refreshButton = () => {
    fetchOrder();
    winnerHistory();
    resetState();
  }

  const resetAllData = () => resetState();

  const resetState = () => {
    setIsPrintBtnDisable(false);
    setOrderPrint(prev => !prev);
    setSelectedRowsLeft([]);
    setSelectedRowsMiddle([]);
    setSelectedButtons(new Set());
    setSelectedNumbers(new Set());
    setAmounts({});
    setCurrentAmount('');
    setAllData({});
    setLastSelected(null);
    // ensure FC-group mode is cleared when state resets
    setIsFcGroupSelected(false);
    if (hiddenInputRef.current) hiddenInputRef.current.value = '';
    // clear base amount tracking and right-click counters
    setBaseAmounts({});
    // also clear mirror refs so subsequent quick clicks read empty state
    amountsRef.current = {};
    allDataRef.current = {};
    baseAmountsRef.current = {};
    rightClickCountsRef.current = {};
    // clear any pending chip selection
    setPendingChipAmount(null);
  };

  const isWithinActiveHours = (value) => setInActiveHours(value);
  const handleOpenModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);
  const cancelOrder = async () => {
    try {
      const data = await lastOrderCancel();
      toast.success(data.message || data.detail || "Order successfully canceled!", { position: "top-center", autoClose: 1000 });
    } catch (error) {
      toast.warn(error, { position: "top-center", autoClose: 1000 });
    }
    handleCloseModal();
  };

  const latestResult = winnersHistory[0];
  let singledigit = [];
  let isjocker = false;
  let lastDigit = null;
  if (latestResult) {
    singledigit = latestResult.product_number.split("").map(Number);
    const total = singledigit.reduce((acc, d) => acc + d, 0);
    lastDigit = total % 10;
    isjocker = latestResult?.is_jocker;
  }

  // chip values for bottom chips row
  const chipValues = [
    { img: rupee5, value: '5' },
    { img: rupee10, value: '10' },
    { img: rupee25, value: '25' },
    { img: rupee50, value: '50' },
    { img: rupee100, value: '100' },
    { img: rupee200, value: '200' },
    { img: rupee500, value: '500' },
  ];

  const convertTo12Hour = (timeStr) => {
    let [hour, minute] = timeStr.split(":").map(Number);
    const ampm = hour >= 12 ? "PM" : "AM";
    hour = hour % 12 || 12; // convert 0 → 12
    return `${hour}:${minute.toString().padStart(2, "0")} ${ampm}`;
  };


  // Select rows 2..13 (inclusive) on BOTH tables
  const selectSP = () => {
    const start = 2, end = 13; // human-friendly
    const leftIndices = [];
    const middleIndices = [];
    const nums = [];

    for (let r = start - 1; r <= end - 1; r++) {
      if (leftTableData[r]) {
        leftIndices.push(r);
        nums.push(...leftTableData[r]);
      }
      if (middleTableData[r]) {
        middleIndices.push(r);
        nums.push(...middleTableData[r]);
      }
    }

    if (pendingChipAmount !== null) {
      applyAmountToNumbers(nums, pendingChipAmount);
    } else {
      setSelectedRowsLeft(leftIndices);
      setSelectedRowsMiddle(middleIndices);
      addNumbersToSelection(nums, true); // replace current number selection
    }
    hiddenInputRef.current?.focus();
  };

  // Select rows 14..22 (inclusive) on BOTH tables
  const selectDP = () => {
    const start = 14, end = 22;
    const leftIndices = [];
    const middleIndices = [];
    const nums = [];

    for (let r = start - 1; r <= end - 1; r++) {
      if (leftTableData[r]) {
        leftIndices.push(r);
        nums.push(...leftTableData[r]);
      }
      if (middleTableData[r]) {
        middleIndices.push(r);
        nums.push(...middleTableData[r]);
      }
    }

    if (pendingChipAmount !== null) {
      applyAmountToNumbers(nums, pendingChipAmount);
    } else {
      setSelectedRowsLeft(leftIndices);
      setSelectedRowsMiddle(middleIndices);
      addNumbersToSelection(nums, true);
    }
    hiddenInputRef.current?.focus();
  };

  // Select only the last row from BOTH tables
  const selectTP = () => {
    const lLast = leftTableData.length - 1;
    const mLast = middleTableData.length - 1;
    const leftIndices = leftTableData[lLast] ? [lLast] : [];
    const middleIndices = middleTableData[mLast] ? [mLast] : [];
    const nums = [];

    if (leftIndices.length) nums.push(...leftTableData[lLast]);
    if (middleIndices.length) nums.push(...middleTableData[mLast]);

    if (pendingChipAmount !== null) {
      applyAmountToNumbers(nums, pendingChipAmount);
    } else {
      setSelectedRowsLeft(leftIndices);
      setSelectedRowsMiddle(middleIndices);
      addNumbersToSelection(nums, true);
    }
    hiddenInputRef.current?.focus();
  };


  return (
    <div className={`mainDiv col-md-12 ${isSpinning ? 'spin-page' : ''}`}>
      {/* Interaction blocker — sits above everything and prevents clicks */}
      {isInteractionDisabled && (
        <div
          className={`interaction-blocker ${isSpinning && !showNoMoreBeatsPopup ? 'transparent-blocker' : ''}`}
          onClick={(e) => e.stopPropagation()}
          onMouseDown={(e) => e.stopPropagation()}
          role="presentation"
        >
          {showNoMoreBeatsPopup ? (
            <div className="no-beats-popup" role="alert" aria-live="assertive">
              <div className="no-beats-title">No More Beats</div>
              <div className="no-beats-sub">Betting closed for this round</div>
              <div className="no-beats-hint">Get ready — results coming up!</div>
            </div>
          ) : null}
        </div>
      )}

      <input
        type="text"
        ref={hiddenInputRef}
        style={{ position: "absolute", left: "-9999px" }}
        onKeyDown={handleKeyboardAmountInput}
      />

      <div className="slots">
        {winnersHistory.slice(0, 20).map((s, i) => {
          const sum = s.product_number.split("").reduce((acc, digit) => acc + parseInt(digit, 10), 0);
          const lastDigit = sum % 10;
          return (
            <div key={i} className="slot">
              {/* time on its own row */}
              <div className="slot-time">{convertTo12Hour(s.session_time)}</div>

              {/* product number, joker icon (if any) and last digit in a single row */}
              <div className="slot-row">
                <div className="slot-product">{s.product_number}</div>
                <span className='spanx'>x</span>
                <div className="slot-last">{lastDigit}</div>
                {s.is_jocker && (
                  <img src={jocker} className="slot-joker" alt="jocker" />
                )}
              </div>
            </div>
          );
        })}
      </div>

      <div className={`homepage table-container ${!inActiveHours ? "disabled" : ""}`}>
        <div className="table-wrapper sp-table">
          <table className='tables'>
            <tbody>
              {renderTable(leftTableData, selectedRowsLeft, setSelectedRowsLeft)}
            </tbody>
          </table>
        </div>

        <div className={`balaji-container ${showResultAnim ? 'result-animate' : ''} ${isSpinning ? 'spin-active' : ''}`}>
          {/* Header */}
          <div className="header">
            <img src={logoutss} onClick={() => logout()} title='LOgout' className='logoutimg' />
            <img src={acountimgs} onClick={() => openAccountPopup()} title='Acoount Info' className='acountimg' />
            <img src={userINFO} onClick={() => openReportPopup()} title="User Info" className='userINFO' />
            <button title='Refresh Button' onClick={() => refreshButton()} className='refreshBtn'><IoMdRefresh size={50} /></button>
            <img src={balajilogo} className='balajiimg' />
          </div>

          <div className='info-row'>
            <div className="info-row-left">
              <div className="label">Server Time</div>
              <div>
                <div className="value">{time.toLocaleString()}</div>
              </div>
            </div>
            <div className="info-row-rigth">
              <div className="label">Player ID</div>
              <div className="value">{walletData[0]?.user_id || "194"}</div>
            </div>
          </div>

          <div className="logos">
            <JokerBadge isjocker={isjocker} size={isSpinning ? 220 : showResultAnim ? 160 : 120} intervalMinutes={5} enableAutoSchedule={true} />
          </div>

          {/* Removed extra loader spinner — numbers will still animate during spin */}


          <div className="number-row">
            {isSpinning ? (
              numbers.map((n, idx) => (
                <div key={idx} className="spinningnumber-column">
                  <div className="spinningnum-box spinningspinning">
                    <div className="spinningdigit-reel">
                      {Array.from({ length: 10 }, (_, i) => (
                        <div key={i} className="spinningdigit">{i}</div>
                      ))}
                    </div>
                  </div>
                </div>
              ))
            ) : (
              singledigit.length === 3 && (
                <>
                  {singledigit.map((d, idx) => (
                    <div key={idx} className="number-column">
                      <div
                        className={`num-box ${showResultAnim ? 'animate-digit' : ''}`}
                        style={{ animationDelay: showResultAnim ? `${idx * 140}ms` : '0ms' }}
                      >
                        <span className="digit">{d}</span>
                      </div>
                      {idx === 1 && <div className="timer">{formatTime(timer)}</div>}
                      {idx === 2 && (
                        <div className={`big-number ${showResultAnim ? 'animate-big' : ''}`}>{lastDigit}</div>
                      )}
                    </div>
                  ))}
                </>
              )
            )}
          </div>

          {/* Chips */}
          <div className="chips-row">
            {chipValues.map((chip, i) => (
              <div key={i} className="chip">
                <img
                  src={chip.img}
                  className="chip-circle"
                  alt={'chip-' + chip.value}
                  style={{
                    cursor: 'pointer',
                    // simple visual indicator when a chip is pending
                    boxShadow: pendingChipAmount === chip.value ? '0 0 0 3px rgba(10,116,218,0.25)' : undefined
                  }}
                  onClick={() => {
                    // If user already has a selection, apply immediately (preserve previous behaviour)
                    if ((selectedNumbers && selectedNumbers.size > 0) || (selectedRowsLeft && selectedRowsLeft.length > 0) || (selectedRowsMiddle && selectedRowsMiddle.length > 0) || lastSelected) {
                      handleAmountSelect(chip.value);
                      setPendingChipAmount(null);
                    } else {
                      // Toggle pending state: click a chip then click a number to apply
                      if (pendingChipAmount === chip.value) setPendingChipAmount(null); else setPendingChipAmount(chip.value);
                    }
                  }}
                />
              </div>
            ))}
          </div>

          <div
            ref={wrapperRef}
            className="barcode-wrapper"
            style={{ position: "relative", margin: "30px 0 0 0", display: "inline-block" }}
          >
            <img
              src={Barcodeimg}
              alt="Barcode"
              className="barcode-image"
              style={{
                cursor: "pointer",
                display: "block",
                visibility: barcodeInputVisible ? "hidden" : "visible" // preserve layout
              }}
              onClick={onBarcodeClick}
            />

            {barcodeInputVisible && (
              /* overlay container that matches the image size exactly */
              <div className="barcode-input-overlay" aria-hidden={!barcodeInputVisible}>
                {/* Keep your component as-is. Pass the ref if it supports forwardRef */}
                <BarcodeInput
                  ref={barcodeInputRef}
                  className="barcode-input-component"
                /* pass any props your BarcodeInput needs here */
                />
              </div>
            )}
          </div>

          <div style={{ display: "none" }}>
            {orderPrintData && <PrintSlip orderData={orderPrintData} timeOffsetMs={timeOffsetRef.current} ref={componentRef} />}
          </div>
        </div>

        <div className="table-wrapper dp-table">
          <table className='tables'>
            <tbody>
              {renderTable(middleTableData, selectedRowsMiddle, setSelectedRowsMiddle)}
            </tbody>
          </table>
        </div>

        <div className="left-container">
          <img src={singleDouble} alt="background" />
          <img src={FCGroupBtn} title={isFcGroupSelected ? 'FC Group mode: ON' : 'FC Group mode'} className={`leftimgs fcimg ${isFcGroupSelected ? 'active' : ''}`} alt="FC Group" onClick={openFcgroupPopup} style={{ cursor: 'pointer' }} />
          <img src={allsp} className="leftimgs" alt="All SP" onClick={selectSP} style={{ cursor: 'pointer' }} />
          <img src={alldp} className="leftimgs" alt="All DP" onClick={selectDP} style={{ cursor: 'pointer' }} />
          <img src={alltp} className="leftimgs" alt="All TP" onClick={selectTP} style={{ cursor: 'pointer' }} />
        </div>
      </div>

      <div className='footer'>
        <div className="button-row">
          <div className="half left-half" style={{ position: "relative" }}>
            <img src={balanceBtn} className='balanccc' alt="Balance" />
            <img src={RupeesBtn} alt="Rupees" />
            <span className='showBalance'>{walletData[0]?.balance_wallet}</span>
            <div className={(selectedAdvanceSessions && selectedAdvanceSessions.length > 0) ? "totals-block" : "total-blocksisadvance"}>
              <span className="total-main">{totalAmount}</span>
              {selectedAdvanceSessions && selectedAdvanceSessions.length > 0 && (
                <span className='advance-total'>
                  Total x{selectedAdvanceSessions.length}: ₹ {totalAmount * selectedAdvanceSessions.length}
                </span>
              )}
              {queuedAdvanceCount > 0 && (
                <span className='queued-total'>
                  Queued x{queuedAdvanceCount}: ₹ {totalAmount * queuedAdvanceCount}
                </span>
              )}
            </div>
          </div>
          <div className="half right-half">
            <img src={PrintBtn} alt="Print"
              style={{
                cursor: !isPrintBtnDisable ? "pointer" : "not-allowed",
                opacity: !isPrintBtnDisable ? 1 : 0.5, // visually show disabled
                pointerEvents: !isPrintBtnDisable ? "auto" : "none", // actually disable clicks
              }}
              onClick={!isPrintBtnDisable ? () => handlePlaceOrder(null, selectedAdvanceSessions.length ? selectedAdvanceSessions : null) : undefined} />
            <img src={RePrintBtn} alt="RePrint" style={{ cursor: "pointer" }} onClick={openReprintPopup} />
            <img src={CancelBtn} alt="Cancel" style={{ cursor: "pointer" }} onClick={handleOpenModal} />
            <img src={ClearBtn} alt="Clear" style={{ cursor: "pointer" }} onClick={resetAllData} />

            {/* Advance button or inline input (same size as button) */}
            <div style={{ display: 'inline-flex', alignItems: 'center' }}>
              <img
                src={AdvanceBtn}
                alt="Advance"
                style={{ cursor: 'pointer' }}
                onClick={() => { setAdvanceSessionsModalOpen(true); generateAdvanceTimes(); setTempSelectedAdvanceSessions(selectedAdvanceSessions); }}
                title="Select upcoming sessions to place orders for"
              />
              {selectedAdvanceSessions && selectedAdvanceSessions.length > 0 && (
                <div style={{ display: 'inline-flex', alignItems: 'center', marginLeft: 8 }}>
                  <span style={{ color: '#fff', fontWeight: 'bold' }} title={`${selectedAdvanceSessions.length} sessions selected`}>✅ {selectedAdvanceSessions.length}</span>
                  <button className="action-btn" onClick={() => setSelectedAdvanceSessions([])} style={{ marginLeft: 6 }}>Clear</button>
                </div>
              )}
              {queuedAdvanceCount > 0 && (
                <div style={{ display: 'inline-flex', alignItems: 'center', marginLeft: 8 }}>
                  <span style={{ color: '#fff', fontWeight: 'bold', background: '#333', padding: '4px 6px', borderRadius: 12 }} title={`${queuedAdvanceCount} sessions queued`}>⏳ {queuedAdvanceCount}</span>
                </div>
              )}
            </div>

            <img src={ResultBtn} alt="Result" style={{ cursor: "pointer" }} onClick={openResultPopup} />
          </div>
        </div>
      </div>

      {openPage && <Result resultData={winnersHistory} onClose={() => setOpenPage(false)} />}
      {changePassword && <ChangePass onClose={() => setChangePassword(false)} />}
      {advanceSessionsModalOpen && (
        <div className="popup-overlay" role="dialog" aria-modal="true">
          <div className="popup-container modern-popup">

            {/* Close button */}
            <button className="close-btn"
              onClick={() => {
                setTempSelectedAdvanceSessions(selectedAdvanceSessions);
                setAdvanceSessionsModalOpen(false);
              }}
            >
              &times;
            </button>

            <h2 className="popup-title">Select Upcoming Sessions</h2>
            <p className="popup-subtitle">
              Select one or more sessions to schedule orders for. Click OK to continue.
            </p>

            <div className="session-list">
              {advanceTimes.map((t) => {
                const isSelected = tempSelectedAdvanceSessions.includes(t.iso);
                return (
                  <div
                    key={t.iso}
                    className={`session-item ${isSelected ? "selected" : ""}`}
                    onClick={() => toggleTempAdvanceSession(t.iso)}
                  >
                    <div className="session-label">
                      {t.label}
                      <small className="session-iso">({t.iso})</small>
                    </div>

                    {/* Hidden checkbox - logic kept same */}
                    <input
                      type="checkbox"
                      checked={isSelected}
                      readOnly
                      style={{ display: "none" }}
                    />
                  </div>
                );
              })}
            </div>

            <div className="popup-footer">
              <div>
                <button className="action-btn" onClick={() => selectAllTempAdvance()}>
                  Select All
                </button>
                <button className="action-btn" onClick={() => clearTempAdvance()} style={{ marginLeft: 8 }}>
                  Clear
                </button>
              </div>

              <div>
                <button
                  className="action-btn primary"
                  onClick={() => {
                    setSelectedAdvanceSessions(tempSelectedAdvanceSessions);
                    setAdvanceSessionsModalOpen(false);
                  }}
                >
                  OK
                </button>

                <button
                  className="action-btn"
                  onClick={() => {
                    setTempSelectedAdvanceSessions(selectedAdvanceSessions);
                    setAdvanceSessionsModalOpen(false);
                  }}
                  style={{ marginLeft: 8 }}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {isOrderModelOpen && (
        <OrderModal investedDict={orderData} sessionTime={getSessionTime()} onPlaceOrder={handlePlaceOrder} onCancelOrder={() => setIsOrderModelOpen(false)} />
      )}
      <CancelOrderModal show={showModal} handleClose={handleCloseModal} handleConfirm={cancelOrder} />
      {isAccountOpen && <Account walletData={walletData} onClose={() => setIsAccountOpen(false)} />}
      {isReportOpen && <Report ReportData={allResultData} onClose={() => setIsReportOpen(false)} />}
      {reprintModalOpen && <Reprint onClose={() => setReprintModalOpen(false)} />}

      <ToastContainer />
    </div>
  );
};

export default HomePage;
